import { SxProps, Theme } from '@mui/material';

type TicketsTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: TicketsTableColumn[] = [
  {
    key: 'truck_and_vendor',
    title: 'Truck & Vendor',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'material',
    title: 'Material',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'ticket',
    title: 'Ticket',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'print_time',
    title: 'Print Time',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'status',
    title: 'Status',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'source',
    title: 'Source',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
